import * as React from "react";
import clsx from "clsx";

interface Props {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  label?: string;
  size?: "xs" | "sm" | "md" | "lg";
  disabled?: boolean;
}

export const Toggle: React.FC<Props> = ({ enabled, onChange, label, size = "md", disabled = false }) => {
  const sizeClasses = {
    xs: "h-3 w-6",
    sm: "h-4 w-7",
    md: "h-5 w-9",
    lg: "h-6 w-11",
  };

  const thumbSizeClasses = {
    xs: "h-2 w-2",
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  };

  const translateClasses = {
    xs: "translate-x-3",
    sm: "translate-x-3",
    md: "translate-x-4",
    lg: "translate-x-5",
  };

  return (
    <div className="flex items-center">
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        onClick={() => onChange(!enabled)}
        disabled={disabled}
        className={clsx(
          "relative inline-flex items-center rounded-full",
          sizeClasses[size],
          enabled ? "bg-desert-sand-400" : "bg-gray-200",
          { "cursor-not-allowed opacity-50": disabled },
        )}
      >
        <span className="sr-only">Enable {label}</span>
        <span
          className={`${
            enabled ? translateClasses[size] : "translate-x-0.5"
          } inline-block ${thumbSizeClasses[size]} transform rounded-full bg-white transition`}
        />
      </button>
      {label && <span className="ml-2 text-sm">{label}</span>}
    </div>
  );
};
